"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("styled-components").css`
    .affix-right & {
        .image {
            background-position: center left;
        }
    }
    .image {
        aspect-ratio: 16 / 9;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center right;
        border-radius: 20px;
    }
`;exports.default=e,exports.stylesHeroImage=e;
//# sourceMappingURL=styles.js.map
